import { render } from "./WithdrawApplyView.vue?vue&type=template&id=652bbe10&scoped=true"
import script from "./WithdrawApplyView.vue?vue&type=script&lang=js"
export * from "./WithdrawApplyView.vue?vue&type=script&lang=js"

import "./WithdrawApplyView.vue?vue&type=style&index=0&id=652bbe10&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652bbe10"]])

export default __exports__